export default __webpack_public_path__ + "static/media/black_cross.b7814294.svg";